import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { IndexClauseSettings } from '../../model/index-clause-settings';

@Injectable()
export class IndexClauseSettingsService extends DataService<IndexClauseSettings> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, IndexClauseSettings, progressBar, 'index-clause-settings');
  }

  protected createModel(modelData: any): IndexClauseSettings {
    return new IndexClauseSettings(modelData);
  }
}
